import type { StepMap } from "@/components/onboarding/components/WelcomeWizard/WelcomeWizard.types";
import { DownloadAppsStep } from "./DownloadAppsStep";
import { IntroVideoStep } from "./IntroVideoStep";

export const PostImportStepsMap: StepMap = {
  "download-apps": {
    id: "download-apps",
    group: "post-import",
    render: props => <DownloadAppsStep {...props} />,
  },
  "intro-video": {
    id: "intro-video",
    group: "post-import",
    render: props => <IntroVideoStep {...props} />,
  },
} as const;
